import { ShoppingBag } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useCart } from '../hooks/useCart'

export function CartIcon() {
  const { itemCount, openCart } = useCart()

  return (
    <Button
      variant="ghost"
      size="icon"
      className="relative"
      onClick={openCart}
      aria-label={`Open cart${itemCount > 0 ? ` (${itemCount} items)` : ''}`}
    >
      <ShoppingBag className="h-5 w-5" />
      {itemCount > 0 && (
        <span className="absolute -right-0.5 -top-0.5 flex h-4 w-4 items-center justify-center rounded-full bg-brand-orange text-[10px] font-bold text-white">
          {itemCount > 9 ? '9+' : itemCount}
        </span>
      )}
    </Button>
  )
}
